<ng-template #buttonTemplate
  ><ng-content select="button"></ng-content
></ng-template>

<ng-template #zelisButtonTemplate
  ><ng-content select="zelis-button"></ng-content
></ng-template>

<ng-template #lozengeTemplate
  ><ng-content select="zelis-theme-lozenge"></ng-content
></ng-template>

<ng-template #iconTemplate
  ><ng-content select="mat-icon"></ng-content
></ng-template>

<ng-template #imageTemplate
  ><ng-content select="img[zelisCalloutCardImage]"></ng-content
></ng-template>

<zelis-card
  [emphasis]="
    emphasisColor ? { position: 'left', color: emphasisColor } : undefined
  "
  [stroke]="variant === 'outlined'"
  [elevated]="variant === 'elevated'"
  (waResizeObserver)="onResize($event)"
>
  <div
    class="flex p-6"
    [class.pl-8]="emphasisColor !== undefined"
    [class]="inferredSize === 'small' ? 'flex-col' : 'flex-row'"
  >
    <div class="flex flex-col flex-1">
      <div
        class="flex flex-row callout-title-container"
        [class.mb-4]="
          inferredSize === 'small' ||
          subtitle ||
          (inferredSize === 'large' && !icon && !image)
        "
      >
        <!-- CONSUMER PROVIDED ICON -->
        <div
          *ngIf="icon"
          id="callout-card-icon"
          class="w-16 h-16 flex justify-center items-center bg-gray-100 text-gray-500 rounded-full"
        >
          <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
        </div>

        <!-- CONSUMER PROVIDED IMAGE -->
        <div
          *ngIf="image"
          class="w-16 h-16 flex justify-center items-center bg-gray-100"
        >
          <ng-container *ngTemplateOutlet="imageTemplate"></ng-container>
        </div>

        <div class="flex flex-1 flex-col" [class]="icon || image ? 'ml-4' : ''">
          <h2
            class="dls-heading-3 font-bold text-palette-m3-system-gray-10 flex-1"
            [innerHTML]="title"
          ></h2>
          <div
            *ngIf="subtitle"
            class="dls-body-2 font-medium text-palette-m3-system-gray-35"
            [innerHTML]="subtitle"
          ></div>
        </div>
      </div>

      <!-- CONSUMER PROVIDED LOZENGE (PLACEMENT FOR SMALL SIZE) -->
      <div *ngIf="lozenge && inferredSize === 'small'" class="mb-4">
        <ng-container *ngTemplateOutlet="lozengeTemplate"></ng-container>
      </div>

      <div [class]="inferredSize === 'large' && (icon || image) ? 'ml-20' : ''">
        <p class="text-base">
          <!-- CONSUMER PROVIDED CONTENT -->
          <ng-content selector="zelis-callout-card-content"></ng-content>
        </p>
      </div>
    </div>

    <!-- CONSUMER PROVIDED BUTTON -->
    <div *ngIf="button" [class]="inferredSize === 'small' ? 'mt-4' : ''">
      <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
    </div>
    <div *ngIf="zelisButton" [class]="inferredSize === 'small' ? 'mt-4' : ''">
      <ng-container *ngTemplateOutlet="zelisButtonTemplate"></ng-container>
    </div>

    <!-- CONSUMER PROVIDED LOZENGE (PLACEMENT FOR LARGE SIZE) -->
    <div *ngIf="lozenge && inferredSize === 'large'">
      <ng-container *ngTemplateOutlet="lozengeTemplate"></ng-container>
    </div>
  </div>
</zelis-card>
